function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 17.5C10.3307 17.5 10.6572 17.4817 10.9784 17.4459L12 20L14 18L18 20L16.0345 15.0862C17.7074 13.4925 18.75 11.243 18.75 8.75C18.75 3.91751 14.8325 0 10 0C5.16751 0 1.25 3.91751 1.25 8.75C1.25 11.243 2.29257 13.4925 3.96549 15.0862L1.99997 20L5.99997 18L7.99997 20L9.02161 17.4459C9.34281 17.4817 9.66926 17.5 10 17.5ZM10.4719 4.34874C10.3157 3.90226 9.68429 3.90226 9.52806 4.34874L8.54557 7.15653C8.4754 7.35709 8.28612 7.49139 8.07363 7.49139H4.97775C4.48447 7.49139 4.28919 8.13 4.69812 8.40588L7.13744 10.0516C7.32579 10.1786 7.40479 10.4167 7.32974 10.6312L6.38325 13.3361C6.22431 13.7903 6.7359 14.1849 7.13483 13.9158L9.72036 12.1714C9.88936 12.0574 10.1106 12.0574 10.2796 12.1714L12.8652 13.9158C13.2641 14.1849 13.7757 13.7903 13.6168 13.3361L12.6703 10.6312C12.5952 10.4167 12.6742 10.1786 12.8626 10.0516L15.3019 8.40588C15.7108 8.13 15.5155 7.49139 15.0222 7.49139H11.9264C11.7139 7.49139 11.5246 7.35709 11.4544 7.15653L10.4719 4.34874Z",
  fill: "currentColor"
});

var SvgInsurance = function SvgInsurance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsurance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insurance.e7ab0eb2.svg";
export { ForwardRef as ReactComponent };